module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray-72ea46d8091519239c08f34ff8b41ad7.png";